import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { Icon } from '@/common/components/Icons/Icon';
import BiometricsToggle from '../../../components/BiometricsToggle/BiometricsToggle';
import NotificationsToggle from '../../../components/NotificationsToggle/NotificationsToggle';
import { LanguageModal } from './components/LanguageModal/LanguageModal';

export const ProfileSettingsSection = () => {
  const { t, i18n } = useTranslation();
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  return (
    <>
      <CardActionGroup
        title={t('dashboard.profile.sections.settings.title')}
        size="sm"
      >
        <CardAction
          icon={<Icon icon="language" />}
          title={t('dashboard.profile.sections.profile.links.settings.title')}
          description={`${t(`dashboard.settings.language.${i18n.language}`)} (${i18n.language})`}
          onPress={() => setShowLanguageModal(true)}
          action={<Icon icon="chevron-right" />}
        />
        {Platform.OS !== 'web' && <BiometricsToggle />}
        {Platform.OS !== 'web' && <NotificationsToggle />}
      </CardActionGroup>
      {showLanguageModal && (
        <LanguageModal onClose={() => setShowLanguageModal(false)} />
      )}
    </>
  );
};
